export default "__VITE_ASSET__BGxzewJy__"